import { ProgramService } from "@adfenix/types";
import { SERVICES_URL } from "api/helper";
import { request as customRequest } from "api/http";

/**
 * This is a subset of the HttpClient generated by the swagger-typescript-api package.
 * It was extracted for two reasons:
 * - So we can modify it and adapt it to the already established API setup found in the http.ts.
 * - To reduce duplication because the library generates one HttpClient per service, and we have a lot of services.
 *
 * We are implementing the interface from ProgramService but the contract is the same for all services.
 */
export class CustomHttpClient implements ProgramService.HttpClient {
  protected encodeQueryParam(key: string, value: string | number) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(
      typeof value === "number" ? value : `${value}`
    )}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key] as string | number);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key] as string[] | number[];
    return value.map(v => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      key => "undefined" !== typeof query[key]
    );
    return keys
      .map(key =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join("&");
  }
  public request = async <T = unknown>({
    body,
    path,
    method,
    type,
    query
  }: ProgramService.FullRequestParams): Promise<T> => {
    if (type && type === "multipart/form-data") {
      // Instead of directly accepting a FormData object the type generation accepts a fully typed object which is then converted to a FormData object.
      // This was removed from the type generation to reduce duplication so we now need to include it here.
      // https://github.com/acacode/swagger-typescript-api/blob/master/templates/base/http-clients/fetch-http-client.ejs#L107C48-L107C48
      body = Object.entries(body || {}).reduce((formData, [key, property]) => {
        if (property instanceof Blob) {
          formData.append(key, property);
        } else if (typeof property === "object" && property !== null) {
          formData.append(key, JSON.stringify(property));
        } else {
          formData.append(key, `${property}`);
        }
        return formData;
      }, new FormData());
    }

    const queryString = query
      ? "?" + this.toQueryString(query as QueryParamsType)
      : "";

    return customRequest(method ?? "GET")(
      `${SERVICES_URL}${path}${queryString}`,
      body
    );
  };
}

export type QueryParamsType = Record<
  string | number,
  string | number | string[] | number[]
>;
